import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import filterIcon from '@assets/filters/filter.svg';
import sortIcon from '@assets/sortby.svg';
import downIcon from '@assets/filters/down.svg';
import './FilterButton.css';

const FilterButton = ({ 
  label = "Filter By",
  options = [],
  value = "",
  onChange,
  type = "filter", // "filter" or "sort"
  className = "",
  iconOnly = false // New prop for icon-only mode
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  const selectedOption = options.find(opt => opt.value === value);
  const displayLabel = selectedOption ? selectedOption.label : label;

  return (
    <div className={`filter-button ${iconOnly ? 'filter-button--icon-only' : ''} ${className}`} ref={dropdownRef}>
      <button
        type="button"
        className={`filter-button__trigger ${isOpen ? 'filter-button__trigger--open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
        aria-label={type === 'filter' ? 'Filter' : 'Sort'}
      >
        {type === 'filter' ? (
          <img src={filterIcon} alt="" className="filter-button__icon" />
        ) : (
          <img src={sortIcon} alt="" className="filter-button__icon" />
        )}
        {!iconOnly && (
          <>
            <span className="filter-button__label">{displayLabel}</span>
            <img 
              src={downIcon} 
              alt="" 
              className={`filter-button__arrow ${isOpen ? 'filter-button__arrow--open' : ''}`} 
            />
          </>
        )}
      </button>

      {isOpen && (
        <div className="filter-button__dropdown">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`filter-button__option ${value === option.value ? 'filter-button__option--selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

FilterButton.propTypes = {
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['filter', 'sort']),
  className: PropTypes.string,
  iconOnly: PropTypes.bool,
};

export default FilterButton;
